@if (type) { @if (type === 'h1') {
<h1 [className]="type" [ngStyle]="styleOverrides">
  @if (labelKey) {
  <span translate>{{ labelKey }}</span>
  } @else {
  <ng-content></ng-content>
  }
</h1>
} @if (type === 'h2') {
<h2 [className]="type" [ngStyle]="styleOverrides">
  @if (labelKey) {
  <span translate>{{ labelKey }}</span>
  } @else {
  <ng-content></ng-content>
  }
</h2>
} @if (type === 'h3') {
<h3 [className]="type" [ngStyle]="styleOverrides">
  @if (labelKey) {
  <span translate>{{ labelKey }}</span>
  } @else {
  <ng-content></ng-content>
  }
</h3>
} @if (type === 'h4') {
<h4 [className]="type" [ngStyle]="styleOverrides">
  @if (labelKey) {
  <span translate>{{ labelKey }}</span>
  } @else {
  <ng-content></ng-content>
  }
</h4>
} @if (type === 'h5') {
<h5 [className]="type" [ngStyle]="styleOverrides">
  @if (labelKey) {
  <span translate>{{ labelKey }}</span>
  } @else {
  <ng-content></ng-content>
  }
</h5>
} @if (type === 'h6') {
<h6 [className]="type" [ngStyle]="styleOverrides">
  @if (labelKey) {
  <span translate>{{ labelKey }}</span>
  } @else {
  <ng-content></ng-content>
  }
</h6>
} }
